import { isKnownRoute } from '../webRoutePaths';

const RN_WEB_HOST = 'mobile.a-bly.com';
const RN_WEB_SUFFIX = `.${RN_WEB_HOST}`;
const PAGE_WEB_URL = 'https://m.a-bly.com';

/**
 * path를 이동 가능한 절대 웹 URL로 변환합니다.
 * RN-Web 호스트(mobile.a-bly.com / stag-N.mobile.a-bly.com)에서만 라우트를 검사합니다.
 * - WEB_ROUTE_PATHS에 선언된 경로 → 접속 origin 유지
 * - 그 외 비RN 경로 → m.a-bly.com, m-stag-N.a-bly.com
 * RN-Web 호스트가 아니면(localhost, 페이지웹 등) 접속 origin을 그대로 사용합니다.
 */
export const resolveWebURL = async (path: string) => {
  if (typeof window === 'undefined') return `${PAGE_WEB_URL}${path}`;

  const { hostname, origin } = window.location;
  const hasStageSubdomain = hostname.endsWith(RN_WEB_SUFFIX);
  const isRNWebHost = hostname === RN_WEB_HOST || hasStageSubdomain;

  if (!isRNWebHost || isKnownRoute(path.split('?')[0])) {
    return `${origin}${path}`;
  }

  const stage = hasStageSubdomain
    ? hostname.slice(0, -RN_WEB_SUFFIX.length)
    : undefined;
  return stage
    ? `https://m-${stage}.a-bly.com${path}`
    : `${PAGE_WEB_URL}${path}`;
};
